import MoneyField from '@/components/fields/money-field.vue';
import PhotoUpload from '@/components/general/photo-upload.vue';
import ProductSearch from './components/product-search.vue';
import ProductView from './components/warranty/product-view.vue';

import {
    validationMixin
} from 'vuelidate';
import {
    required,
    maxLength,
    email,
    requiredIf
} from 'vuelidate/lib/validators';
// This is a Step (Product Warranty) for OrderCreate
// @group OrderCreate

export default {
    mixins: [validationMixin],
    //TODO:
    //- FIX language on change - render date picker
    components: {
        MoneyField,
        PhotoUpload,
        ProductSearch,
        ProductView
    },
    props: {
        jsonDebug: {
            type: Boolean,
            default: true
        },
        selectedProductInfos: {
            type: Object,
            default: null
        }
    },
    validations: {
        radiosReceiptComposite: {
            required
        },
        radiosExtensionComposite: {
            required: requiredIf(function(model) {
                if (this.showRadiosExtensionComposite()) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        radiosExtensionCompositeYear: {
            required: requiredIf(function(model) {
                if (this.showRadiosExtensionCompositeYear()) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        radiosCustomerDevice: {
            required: requiredIf(function(model) {
                if (this.showRadiosCustomerDevice()) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        radiosDeviceUsedComposite: {
            required: requiredIf(function(model) {
                if (this.showRadiosDeviceUsedComposite()) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        radiosDoaQuestion1: {
            required: requiredIf(function(model) {
                if (this.showDoaInfoContainer()) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        radiosDoaQuestion2: {
            required: requiredIf(function(model) {
                if (this.showDoaInfoContainer()) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        radiosWarrantySwap: {
            required: requiredIf(function(model) {
                if (this.showSwapContainer()) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        radiosRepairCenterAction: {
            required: requiredIf(function(model) {
                if (this.checkboxRepairMaxAmountNone && this.showWarrantyExpiredContainer()) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        selectPreEncashmentAmount: {
            required: requiredIf(function(model) {
                if (this.showWarrantyExpiredContainer()) {
                    return true;
                } else {
                    return false;
                }
            }),
        },
        fieldSalesData: {
            required: requiredIf(function(model) {
                if (this.radiosReceiptComposite == 1) {
                    return true;
                } else {
                    return false;
                }
            }),
        },
        checkboxConfirmPreEncashment: {
            checked(val) {
                if (this.selectPreEncashmentAmount > 0 && val) {
                    return true;
                } else if (this.selectPreEncashmentAmount == 0 && !val || !this.selectPreEncashmentAmount && !val) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        warrantyStep: [
            'radiosReceiptComposite',
            'fieldSalesData',
            'radiosExtensionComposite',
            'radiosExtensionCompositeYear',
            'radiosCustomerDevice',
            'radiosDeviceUsedComposite',
            'radiosDoaQuestion1',
            'radiosDoaQuestion2',
            'radiosWarrantySwap',
            // 'checkboxRepairMaxAmountNone',
            // 'repairMaxAmount',
            'radiosRepairCenterAction',
            'checkboxConfirmPreEncashment',
            'selectPreEncashmentAmount'
        ]
    },
    data() {
        return {
            //sample data to be deleted
            warrantyBrand: 24,
            nowMinusBrandWarranty: null,
            warrantyDecision: null,
            warrantyDecisionCode: null,
            warrantyDecisionDetailed: null,
            warrantyResult: {
                'code': null,
                'type': null
            },
            warrantyResultMessages: {
                '01': {
                    type: 'success'
                },
                '02': {
                    type: 'warning'
                },
                '03': {
                    type: 'success'
                },
                '04': {
                    type: 'info'
                },
                '05': {
                    type: 'info'
                },
                '06': {
                    type: 'info'
                },
                '07': {
                    type: 'info'
                },
                '99': {
                    type: 'error'
                }
            },
            fieldSalesData: null,
            radiosReceiptComposite: null,
            imageReceiptComposite: null,
            salesDate: null,
            salesDateMenu: false,
            radiosExtensionComposite: null,
            radiosExtensionCompositeYear: null,
            radiosCustomerDevice: null,
            radiosDeviceUsedComposite: null,
            radiosRepairCenterAction: null,
            radiosDoaQuestion1: null,
            radiosDoaQuestion2: null,
            radiosWarrantySwap: null,
            swapDeviceSaleValue: null,

            warrantyPlusExtensionDate: null,
            todayDate: new Date().toISOString().substr(0, 10),
            // titlePhotoUploadWarrantyReceipt   : "",
            // titlePhotoUploadWarrantyExtension : "",
            repairMaxAmount: null,
            checkboxRepairMaxAmountNone: true,
            repairMaxAmountHint: "no",
            preEncashmentAmountItems: [0.00, 100.00],
            selectPreEncashmentAmount: null,
            checkboxConfirmPreEncashment: false,
            deviceValue: null,
            selectedSwapProduct: null,

            businessCode: {
                BUSINESS_CASE_NO_WARRANTY: 0,
                BUSINESS_CASE_WARRANTY: 1,
                BUSINESS_CASE_DOA: 2,
                BUSINESS_CASE_MAINTENANCE: 3,
                BUSINESS_CASE_WARRANTY_SWAP: 4
            },
            businessCodeDetailed: {
                RECEIPT_YES_WARRANTY_VALID: 1,
                RECEIPT_YES_WARRANTY_VALID_DOA: 2,
                RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_NO: 3,
                RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_VALID_MANDATOR: 4,
                RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_VALID_CUSTOMER: 5,
                RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_EXPIRED: 6,
                RECEIPT_NO_CUSTOMER_DEVICE_YES: 7,
                RECEIPT_NO_CUSTOMER_DEVICE_NO_USED: 8,
                RECEIPT_NO_CUSTOMER_DEVICE_NO_UNUSED: 9,
                RECEIPT_YES_WARRANTY_VALID_SWAP: 10
            }
            //----- TEST ----
        };
    },
    methods: {
        validateAll() {
            // console.info('validate warranty step', this.$refs);
            this.$v.warrantyStep.$touch();
            let refsErrors = false;

            if (this.repairMaxAmountRequired()) {
                // console.info('validate repairMaxAmount', this.$refs.repairMaxAmount.validate());
                if (!this.$refs.repairMaxAmount.validate()) {
                    refsErrors = true;
                }
            }
            if (this.deviceValueRequired()) {
                // console.info('validate deviceValue', this.$refs.deviceValue.validate());
                if (!this.$refs.deviceValue.validate()) {
                    refsErrors = true;
                }
            }
            if (this.uploadReceiptRequired()) {
                // console.info('validate uploadReceipt', this.$refs.uploadReceipt.validate());
                if (!this.$refs.uploadReceipt.validate()) {
                    refsErrors = true;
                }
            }
            if (this.uploadReceiptExtensionRequired()) {
                if (!this.$refs.uploadReceiptExtension.validate()) {
                    refsErrors = true;
                }
            }
            // console.info('refsErrors', refsErrors);
            if (this.$v.warrantyStep.$anyError || refsErrors) {
                this.$emit('step-product-warranty-has-errors');
                return false;
            } else {
                this.$emit('step-product-warranty-is-valid');
                return true;
            }
        },
        onValidateFields() {
            if (this.$v.warrantyStep.$dirty) {
                this.validateAll();
            } else {
                return;
            }
        },
        /**
         * @vuese
         * check the selected data if product is in warranty
         */
        checkIfInWarranty() {
            let now = this.$moment();
            let selectedDate = this.$moment(this.salesDate);
            let selectedMinusBrandWarranty = selectedDate.subtract(this.warrantyBrand, 'months');
            let nowMinusBrandWarranty = this.$moment();
            nowMinusBrandWarranty.subtract(this.warrantyBrand, 'months');
            if (this.$moment(this.salesDate).isBetween(nowMinusBrandWarranty, now)) {
                return true;
            } else {
                return false;
            }
        },
        checkIfIsDoa() {
            if (!this.selectedProductInfos) {
                return;
            }
            if (this.selectedProductInfos.doadays == 0) {
                console.warn('selected product has 0 DOA DAYS');
                return false;
            }
            let now = this.$moment();
            let selectedDate = this.$moment(this.salesDate);
            let nowMinusDoaDays = this.$moment();
            nowMinusDoaDays.subtract(this.selectedProductInfos.doadays, 'days');
            if (this.$moment(this.salesDate).isBetween(nowMinusDoaDays, now)) {
                // console.warn('IS DOA');
                return true;
            } else {
                // console.warn('date is not DOA');
                return false;
            }
        },
        /**
         * @vuese
         * check the selected data with extension year if product is in warranty
         */
        checkIfExtensionDateInWarranty() {
            let now = this.$moment();
            if (this.warrantyPlusExtensionDate.isSameOrAfter(now)) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if warranty field is null
         */
        isWarrantyFieldNull() {
            if (!this.salesDate || this.salesDate == null) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if radiosExtensionComposite should be displayed or not
         */
        showRadiosExtensionComposite() {
            if (this.radiosReceiptComposite == 1 && !this.isWarrantyFieldNull() && !this.checkIfInWarranty() && !this.checkIfIsDoa()) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if radiosExtensionComposite should be displayed or not
         */
        showPhotoUploadWarrantyExtension() {
            if (this.radiosExtensionComposite == 1 && this.radiosReceiptComposite == 1) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if radiosExtensionComposite should be displayed or not
         */
        showRadiosExtensionCompositeYear() {
            if (this.radiosExtensionComposite == 1 && this.radiosReceiptComposite == 1) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if radiosExtensionComposite should be displayed or not
         */
        showWarrantyDecision() {
            let code;

            // ### CASE 01: RECEIPT_YES_WARRANTY_VALID = 1 ###
            if (this.radiosReceiptComposite == 1 && this.checkIfInWarranty() && !this.checkIfIsDoa() && this.selectedProductInfos.warrantyexchange == 0 &&
                this.fieldSalesData && this.$refs.uploadReceipt.validate() ||
                this.radiosReceiptComposite == 1 && this.checkIfInWarranty() && !this.checkIfIsDoa() && (this.radiosDoaQuestion1 == 2 || this.radiosDoaQuestion2 == 2)) {
                this.warrantyDecisionDetailed = this.businessCodeDetailed.RECEIPT_YES_WARRANTY_VALID;
                this.warrantyDecisionCode = this.businessCode.BUSINESS_CASE_WARRANTY;
                code = '01';

                // ### CASE 02: RECEIPT_YES_WARRANTY_VALID_DOA = 2 ###
            } else if (this.radiosReceiptComposite == 1 && this.checkIfIsDoa() && this.radiosDoaQuestion1 == 1 && this.radiosDoaQuestion2 == 1) {
                this.warrantyDecisionDetailed = this.businessCodeDetailed.RECEIPT_YES_WARRANTY_VALID_DOA;
                this.warrantyDecisionCode = this.businessCode.BUSINESS_CASE_DOA;
                code = '02';

                // ### CASE 03: RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_NO = 3 ###
            } else if (this.radiosReceiptComposite == 1 && !this.checkIfInWarranty() && this.radiosExtensionComposite == 2) {
                this.warrantyDecisionDetailed = this.businessCodeDetailed.RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_NO;
                this.warrantyDecisionCode = this.businessCode.BUSINESS_CASE_NO_WARRANTY;
                code = '06';

                // ### CASE 04: RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_VALID_MANDATOR = 4 ###
            } else if (this.radiosReceiptComposite == 1 && !this.checkIfInWarranty() && this.selectedProductInfos.warrantyextensionmandator == 1) {
                this.warrantyDecisionDetailed = this.businessCodeDetailed.RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_VALID_MANDATOR;
                this.warrantyDecisionCode = this.businessCode.BUSINESS_CASE_WARRANTY;
                code = '06';

            } else if (this.radiosReceiptComposite == 1 && !this.checkIfInWarranty() && this.radiosExtensionComposite == 1 && this.radiosExtensionCompositeYear) {
                let date = this.salesDatePlusExtension.get();
                this.warrantyPlusExtensionDate = date;

                // ### CASE 05: RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_VALID_CUSTOMER = 5 ###
                if (this.checkIfExtensionDateInWarranty()) {
                    this.warrantyDecisionDetailed = this.businessCodeDetailed.RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_VALID_CUSTOMER;
                    this.warrantyDecisionCode = this.businessCode.BUSINESS_CASE_WARRANTY;
                    code = '03';

                    // ### CASE 06: RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_EXPIRED = 6 ###
                } else {
                    this.warrantyDecisionDetailed = this.businessCodeDetailed.RECEIPT_YES_WARRANTY_EXPIRED_WARRANTY_EXTENSION_EXPIRED;
                    this.warrantyDecisionCode = this.businessCode.BUSINESS_CASE_NO_WARRANTY;
                    code = '05';
                }

                // ### CASE 07: RECEIPT_NO_CUSTOMER_DEVICE_YES = 7 ###
            } else if (this.radiosReceiptComposite == 2 && this.radiosCustomerDevice == 1) {
                this.warrantyDecisionDetailed = this.businessCodeDetailed.RECEIPT_NO_CUSTOMER_DEVICE_YES;
                this.warrantyDecisionCode = this.businessCode.BUSINESS_CASE_NO_WARRANTY;
                code = '06';

                // ### CASE 08: RECEIPT_NO_CUSTOMER_DEVICE_NO_USED = 8 ###
            } else if (this.radiosReceiptComposite == 2 && this.radiosCustomerDevice == 2 && this.radiosDeviceUsedComposite == 1) {
                this.warrantyDecisionDetailed = this.businessCodeDetailed.RECEIPT_NO_CUSTOMER_DEVICE_NO_USED;
                this.warrantyDecisionCode = this.businessCode.BUSINESS_CASE_MAINTENANCE;
                code = '04';

                // ### CASE 09: RECEIPT_NO_CUSTOMER_DEVICE_NO_UNUSED = 9 ###
            } else if (this.radiosReceiptComposite == 2 && this.radiosCustomerDevice == 2 && this.radiosDeviceUsedComposite == 2) {
                this.warrantyDecisionDetailed = this.businessCodeDetailed.RECEIPT_NO_CUSTOMER_DEVICE_NO_USED;
                this.warrantyDecisionCode = this.businessCode.BUSINESS_CASE_DOA;
                code = '05';

                // ### CASE 10: RECEIPT_YES_WARRANTY_VALID_SWAP = 10 ###
            } else if (this.radiosReceiptComposite == 1 && this.checkIfInWarranty() && this.selectedProductInfos.warrantyexchange == 1) {
                this.warrantyDecisionDetailed = this.businessCodeDetailed.RECEIPT_YES_WARRANTY_VALID_SWAP;
                this.warrantyDecisionCode = this.businessCode.BUSINESS_CASE_WARRANTY_SWAP;
                code = '07';
            }
            // TODO: REMOVE THIS. ONLY FOR DEBUG
            // else {
            //     code = '99';
            // }
            //

            if (code) {
                this.setWarrantyResult(code);
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if radiosExtensionComposite should be displayed or not
         */
        showSalesDate() {
            if (this.radiosReceiptComposite == 1) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if showPhotoUploadWarrantyReceipt should be displayed or not
         */
        showPhotoUploadWarrantyReceipt() {
            if (this.radiosReceiptComposite == 1 && this.radiosReceiptComposite == 1) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if showRadiosCustomerDevice should be displayed or not
         */
        showRadiosCustomerDevice() {
            if (this.radiosReceiptComposite == 2) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if showRadiosDeviceUsedComposite should be displayed or not
         */
        showRadiosDeviceUsedComposite() {
            if (this.radiosReceiptComposite == 2 && this.radiosCustomerDevice == 2) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if showMoneyField should be displayed or not
         */
        showMoneyField() {
            if (this.radiosDeviceUsedComposite == 2 && this.radiosCustomerDevice == 2 || this.radiosDeviceUsedComposite == 1 && this.radiosCustomerDevice == 2) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if showWarrantyExpiredContainer should be displayed or not
         */
        showWarrantyExpiredContainer() {
            if (this.radiosReceiptComposite == 1 && this.radiosExtensionComposite == 2 && !this.checkIfInWarranty()) {
                return true;
            } else if (this.radiosReceiptComposite == 1 && this.radiosExtensionComposite == 1 && !this.checkIfInWarranty() && this.radiosExtensionCompositeYear) {
                let date = this.salesDatePlusExtension.get();
                this.warrantyPlusExtensionDate = date;
                if (!this.checkIfExtensionDateInWarranty()) {
                    return true;
                }
            } else if (this.radiosReceiptComposite == 2 && this.radiosCustomerDevice == 1) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @vuese
         * check if showDoaInfoContainer should be displayed or not
         */
        showDoaInfoContainer() {
            if (this.radiosReceiptComposite == 1 && this.checkIfIsDoa()) {
                return true;
            } else {
                return false;
            }
        },
        /**

        * @vuese
        * check if showSwapContainer should be displayed or not
        */
        showSwapContainer() {
            if (!this.selectedProductInfos) {
                return true;
            } else {
                if (this.selectedProductInfos.warrantyexchange == 1 && this.radiosReceiptComposite == 1 && this.checkIfInWarranty()) {
                    return true;
                } else if (this.radiosReceiptComposite == 1 && this.checkIfInWarranty() && this.radiosDoaQuestion1 == 1 && this.radiosDoaQuestion2 == 1) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        /**
         * @vuese
         * check if setWarrantyResult should be displayed or not
         */
        setWarrantyResult(code) {
            console.log('setWarrantyResult code', code);
            this.warrantyResult.code = code;
            this.warrantyResult.type = this.warrantyResultMessages[code].type;
        },
        /**
         * @vuese
         * check if onRepaiMaxAmoutCheckboxNoneClick should be displayed or not
         */
        onRepaiMaxAmoutCheckboxNoneClick() {
            console.info(this);
            if (!this.checkboxRepairMaxAmountNone) {
                this.$refs.repairMaxAmount.reset();
            }
        },
        getStepData() {
            let ret = {};
            ret.radiosReceiptComposite = this.radiosReceiptComposite;
            ret.imageReceiptComposite = this.imageReceiptComposite;
            ret.radiosExtensionComposite = this.radiosExtensionComposite;
            ret.radiosExtensionCompositeYear = this.radiosExtensionCompositeYear;
            ret.radiosCustomerDevice = this.radiosCustomerDevice;
            ret.radiosDeviceUsedComposite = this.radiosDeviceUsedComposite;
            ret.radiosRepairCenterAction = this.radiosRepairCenterAction;
            ret.selectPreEncashmentAmount = this.selectPreEncashmentAmount;

            ret.repairMaxAmount = this.repairMaxAmount;
            ret.businessCode = this.warrantyDecisionCode;
            ret.businessCodeDetailed = this.warrantyDecisionDetailed;

            return ret;
        },
        getStepSubmitData() {
            // let ret = {};
            // ret.radiosReceiptComposite          = this.radiosReceiptComposite;
            // ret.imageReceiptComposite           = this.imageReceiptComposite;
            // ret.radiosExtensionComposite        = this.radiosExtensionComposite;
            // ret.radiosExtensionCompositeYear    = this.radiosExtensionCompositeYear;
            // ret.radiosCustomerDevice            = this.radiosCustomerDevice;
            // ret.radiosDeviceUsedComposite       = this.radiosDeviceUsedComposite;
            // ret.radiosRepairCenterAction        = this.radiosRepairCenterAction;
            // ret.selectPreEncashmentAmount       = this.selectPreEncashmentAmount;


            //TODO: under work
            let warranty = {};

            warranty.businessCase = 1;
            warranty.businessCaseDetailed = 1;
            warranty.customerDevice = 0;
            warranty.customerDeviceUsed = 0;
            // warranty.substitution.salesPriceOriginalDevice      = '';
            // warranty.substitution.decision                      = 0;
            // warranty.doaSubstitution.salesPriceOriginalDevice   = '';
            // warranty.doaSubstitution.decision                   = 0;
            // warranty.substitutionDevice.inventoryNumber         = '';
            // warranty.substitutionDevice.serialNumber            = '';
            warranty.deviceValue = '';
            warranty.extension = '';
            warranty.validExtension = 0;

            if (this.selectPreEncashmentAmount) {
                warranty.preEncashment = this.selectPreEncashmentAmount;
            } else {
                warranty.preEncashment = '';
            }

            warranty.repairMaxAmount = '';
            warranty.repairMaxAmountNone = false;
            warranty.salesDate = '2019-11-20';
            warranty.validDocument = 1;
            warranty.repairCenterAction = 0;
            warranty.originalPacking = 0;
            warranty.contentComplete = 0;
            // warrantyPdfs                                        = [];

            return warranty;
        },
        repairMaxAmountRequired() {
            if (this.showWarrantyExpiredContainer() && this.checkboxRepairMaxAmountNone) {
                return true;
            } else {
                return false;
            }
        },
        deviceValueRequired() {
            console.info('deviceValueRequired', this.showRadiosDeviceUsedComposite());
            if (this.showRadiosDeviceUsedComposite()) {
                console.info('true');
                return true;
            } else {
                console.info('false');
                return false;
            }
        },
        uploadReceiptRequired() {
            if (this.radiosReceiptComposite == 1) {
                return true;
            } else {
                return false;
            }
        },
        uploadReceiptExtensionRequired() {
            if (this.showPhotoUploadWarrantyExtension()) {
                return true;
            } else {
                return false;
            }
        },
        onSelectSwapProduct(product) {
            console.info('onSelectProduct product warranty step', product);
            if (product != null) {
                this.selectedSwapProduct = product;
            }
        },
        onClearSelectedSwapProduct() {
            console.info('clear product event', this.$refs);
            this.$refs.productViewSwap.resetValues();
        },
        repairMaxAmountIfHintOrNot() {
            if (this.checkboxRepairMaxAmountNone) {
                this.repairMaxAmountHint = "no";
                return false;
            }
            this.repairMaxAmountHint = "yes";
            return true;
        },
        onSalesDatePickerInput() {
            console.info('balllll', this.$v.warrantyStep);
            this.$v.warrantyStep.$reset();
            this.salesDateMenu = false;
            this.formatDate();

        },
        formatDate() {
            let date;
            if (this.salesDate) {
                date = new Date(this.salesDate);
            } else {
                // date = new Date();
                return false;
            }
            this.fieldSalesData = this.$moment(date).format('DD.MM.YYYY');
            return true;
        },
        getWarrantyDecisionCases() {
            let ret = {};
            ret.businessCode = this.warrantyDecisionCode;
            ret.businessCodeDetailed = this.warrantyDecisionDetailed;
            return ret;
        }
    },
    watch: {
        //TODO: does not work
        localeLang() {
            return this.$i18n.locale;
        },
        warrantyDecision() {
            console.info('warrantyDecision watch');
        },
        '$v.warrantyStep.$anyError': function(errors) {
            if (errors) {
                this.$emit('step-product-warranty-has-errors');
            } else {
                this.$emit('step-product-warranty-is-valid');

            }
        },
        // '$v.warrantyStep.$dirty' : function(dirty) {
        //     if (!dirty && !this.$v.warrantyStep.$anyError) {
        //         this.$emit('step-product-warranty-is-valid');
        //     } else {
        //         if (this.$v.stepProductData.$anyError) {
        //             this.$emit('step-product-warranty-has-errors');
        //         }
        //     }
        // }
    },
    computed: {
        localeLang() {
            console.info('lang', this.$i18n.locale);
            return this.$i18n.locale;
        },
        salesDatePlusExtension: {
            // getter
            get: function() {
                let selectedDate = this.$moment(this.salesDate);
                selectedDate.add(this.warrantyBrand, 'months');
                selectedDate.add(this.radiosExtensionCompositeYear, 'years');
                return selectedDate;
            },
            // setter
            set: function(newValue) {
                console.info(newValue);
            }
        },
        radiosReceiptCompositeErrors() {
            const errors = [];
            if (!this.$v.radiosReceiptComposite.$dirty) {
                return errors;
            }
            if (!this.$v.radiosReceiptComposite.required) {
                errors.push('radiosReceiptComposite is required.');
            }
            return errors;
        },
        fieldSalesDataErrors() {
            const errors = [];
            if (!this.$v.fieldSalesData.$dirty) {
                return errors;
            }
            if (!this.$v.fieldSalesData.required) {
                errors.push('fieldSalesData is required.');
            }
            return errors;
        },

        radiosExtensionCompositeErrors() {
            const errors = [];
            if (!this.$v.radiosExtensionComposite.$dirty) {
                return errors;
            }
            if (!this.$v.radiosExtensionComposite.required) {
                errors.push('radiosExtensionComposite is required.');
            }
            return errors;
        },
        radiosExtensionCompositeYearErrors() {
            const errors = [];
            if (!this.$v.radiosExtensionCompositeYear.$dirty) {
                return errors;
            }
            if (!this.$v.radiosExtensionCompositeYear.required) {
                errors.push('radiosExtensionCompositeYear is required.');
            }
            return errors;
        },
        radiosCustomerDeviceErrors() {
            const errors = [];
            if (!this.$v.radiosCustomerDevice.$dirty) {
                return errors;
            }
            if (!this.$v.radiosCustomerDevice.required) {
                errors.push('radiosCustomerDevice is required.');
            }
            return errors;
        },
        radiosDeviceUsedCompositeErrors() {
            const errors = [];
            if (!this.$v.radiosDeviceUsedComposite.$dirty) {
                return errors;
            }
            if (!this.$v.radiosDeviceUsedComposite.required) {
                errors.push('radiosDeviceUsedComposite is required.');
            }
            return errors;
        },
        radiosRepairCenterActionErrors() {
            const errors = [];
            if (!this.$v.radiosRepairCenterAction.$dirty) {
                return errors;
            }
            if (!this.$v.radiosRepairCenterAction.required) {
                errors.push('radiosRepairCenterAction is required.');
            }
            return errors;
        },
        radiosDoaQuestion1Errors() {
            const errors = [];
            if (!this.$v.radiosDoaQuestion1.$dirty) {
                return errors;
            }
            if (!this.$v.radiosDoaQuestion1.required) {
                errors.push('radiosDoaQuestion1 is required.');
            }
            return errors;
        },
        radiosDoaQuestion2Errors() {
            const errors = [];
            if (!this.$v.radiosDoaQuestion2.$dirty) {
                return errors;
            }
            if (!this.$v.radiosDoaQuestion2.required) {
                errors.push('radiosDoaQuestion2 is required.');
            }
            return errors;
        },
        radiosWarrantySwapErrors() {
            const errors = [];
            if (!this.$v.radiosWarrantySwap.$dirty) {
                return errors;
            }
            if (!this.$v.radiosWarrantySwap.required) {
                errors.push('radiosWarrantySwap is required.');
            }
            return errors;
        },

        selectPreEncashmentAmountErrors() {
            const errors = [];
            if (!this.$v.selectPreEncashmentAmount.$dirty) {
                return errors;
            }
            if (!this.$v.selectPreEncashmentAmount.required) {
                errors.push('selectPreEncashmentAmount is required.');
            }
            return errors;
        },
        checkboxConfirmPreEncashmentErrors() {
            const errors = [];
            if (!this.$v.checkboxConfirmPreEncashment.$dirty) {
                return errors;
            }
            if (!this.$v.checkboxConfirmPreEncashment.checked) {
                errors.push('Bitte bestätigen Sie ...');
            }
            return errors;
        },
    },
};
